function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#58595b;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Data science");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer_1 2"
}, React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-1",
  width: 45.67,
  height: 7.31
}), React.createElement("rect", {
  className: "cls-1",
  y: 83.35,
  width: 45.67,
  height: 7.31
}), React.createElement("rect", {
  className: "cls-1",
  x: 38.36,
  y: 7.31,
  width: 7.31,
  height: 76.04
})));

var SvgData = function SvgData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 45.67 90.66",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data.bde1ebbf.svg";
export { ForwardRef as ReactComponent };